import { Link } from "gatsby"
import React from "react"

import Layout from "@components/Layout/Layout"

import Button from "@components/Button/Button"
import HeroSmall from "@components/HeroSmall/HeroSmall"
import { SEO } from "@components/SEO/SEO"

const elements = {
  fr: {
    classic: {
      name: "Prémur Mur Préfabriqué Classique",
      slug: "premur-mur-prefabrique",
    },
    thermal: {
      name: "Prémur Mur Préfabriqué Thermique",
      slug: "premur-mur-prefabrique/thermique",
    },
    green: {
      name: "Prémur Mur Préfabriqué Bas Carbone",
      slug: "premur-mur-prefabrique/bas-carbone",
    },
    architectural: {
      name: "Prémur Mur Préfabriqué Architecutral",
      slug: "premur-mur-prefabrique/architectural",
    },
    integral: {
      name: "Prémur Mur Préfabriqué Intégral",
      slug: "premur-mur-prefabrique/integral",
    },
    cladding: {
      name: "Panneau de bardage BFUHP",
      slug: "panneau-de-bardage-bfuhp",
    },
    slab: {
      name: "Predalle",
      slug: "predalle",
    },
    concrete: {
      name: "Beton Prêt à l'Emploi",
      slug: "beton",
    },
  },
  de: {
    classic: {
      name: "Doppelwand",
      slug: "de/doppelwand",
    },
    thermal: {
      name: "Thermowand",
      slug: "de/doppelwand/thermo",
    },
    green: {
      name: "Thermowand Green",
      slug: "de/doppelwand/green",
    },
    architectural: {
      name: "Architektonische",
      slug: "de/doppelwand/architektonische",
    },
    integral: {
      name: "Integral",
      slug: "de/doppelwand/integral",
    },
    cladding: {
      name: "Fassadenplatten UHPC FClad®",
      slug: "de/fassadensystem",
    },
    slab: {
      name: "Elementdecke",
      slug: "de/elementdecke",
    },
    concrete: {
      name: "Beton Prêt à l'Emploi",
      slug: "beton",
    },
  },
  en: {
    classic: {
      name: "Precast wall",
      slug: "en/precast-wall",
    },
    thermal: {
      name: "Precast Thermal wall",
      slug: "en/precast-wall/thermal",
    },
    green: {
      name: "Prémur Mur Préfabriqué Bas Carbone",
      slug: "premur-mur-prefabrique/bas-carbone",
    },
    architectural: {
      name: "Precast Architectural wall",
      slug: "en/precast-wall/architectural",
    },
    integral: {
      name: "Precast Integral wall",
      slug: "en/precast-wall/integral",
    },
    cladding: {
      name: "Cladding Panel FClad®",
      slug: "en/cladding-panels",
    },
    slab: {
      name: "Precast Slab",
      slug: "en/precast-slab",
    },
    concrete: {
      name: "Beton Prêt à l'Emploi",
      slug: "beton",
    },
  },
}

const RealisationsTemplate = ({ pageContext }) => {
  const { realisation } = pageContext
  const { lang } = pageContext

  return (
    <Layout lang={lang}>
      <HeroSmall
        title={
          pageContext.lang === "fr"
            ? realisation.title
            : pageContext.lang === "de"
              ? realisation.translations.germanTitle
              : realisation.translations.englishTitle
        }
        alt={
          pageContext.lang === "fr"
            ? realisation.title
            : pageContext.lang === "de"
              ? realisation.translations.germanTitle
              : realisation.translations.englishTitle
        }
        backgroundHero={realisation.featuredImage.node.gatsbyImage}
      >
        <div className="space-y-3 bg-white p-4 text-lg">
          <p className="italic">
            {realisation.metaData.localisation} - {realisation.metaData.annee}
          </p>
          <div>
            <p>
              {pageContext.lang === "fr" && "Architecte : "}
              {pageContext.lang === "de" && "Architekt : "}
              {pageContext.lang === "en" && "Architect : "}
              <a
                href={realisation.metaData.architecteSlug}
                target="_blank"
                rel="noreferrer noopenner"
              >
                {realisation.metaData.architecte}
              </a>
            </p>
            <p>
              {pageContext.lang === "fr" && "Élément(s) : "}
              {pageContext.lang === "de" && "Element(s) : "}
              {pageContext.lang === "en" && "Element(s) : "}
              {realisation.metaData.elements.map((element, i) => (
                <>
                  <Link
                    key={element}
                    to={`/${elements[pageContext.lang][element].slug}/`}
                  >
                    {elements[pageContext.lang][element].name}
                  </Link>
                  {i < realisation.metaData.elements.length - 1 ? " - " : null}
                </>
              ))}
            </p>
          </div>
          {pageContext.lang === "fr" && realisation.metaData.custom && (
            <Link
              className="text-sm"
              to="/elements-speciaux-beton/"
              style={{ display: "block" }}
            >
              ← Retour aux éléments spéciaux
            </Link>
          )}
          {pageContext.lang === "fr" && (
            <Link className="text-sm" to="/realisations/">
              ← Retour aux réalisations
            </Link>
          )}
          {pageContext.lang === "de" && (
            <Link to="/de/unsere-referenzen/">← Unsere referenzen</Link>
          )}
          {pageContext.lang === "en" && (
            <Link to="/en/achievements/">← All achievements</Link>
          )}
        </div>
      </HeroSmall>
      <section className="mx-auto my-10 max-w-3xl space-y-10 max-lg:px-5 [&_>div]:space-y-6 [&_img]:mb-5 [&_ul]:list-inside [&_ul]:list-disc">
        {pageContext.lang === "fr" && (
          <div dangerouslySetInnerHTML={{ __html: realisation.content }} />
        )}
        {pageContext.lang === "de" && (
          <div
            dangerouslySetInnerHTML={{
              __html: realisation.translations.germanContent,
            }}
          />
        )}
        {pageContext.lang === "en" && (
          <div
            dangerouslySetInnerHTML={{
              __html: realisation.translations.englishContent,
            }}
          />
        )}

        <div className="flex flex-col items-start gap-y-1 !space-y-0">
          {pageContext.lang === "fr" && realisation.metaData.custom && (
            <Button
              buttonURL="/elements-speciaux-beton/"
              buttonString="← Retour aux éléments spéciaux"
            />
          )}

          {pageContext.lang === "fr" && (
            <Button
              buttonURL="/realisations/"
              buttonString="← Nos autres réalisations"
            />
          )}
          {pageContext.lang === "de" && (
            <Button
              buttonURL="/de/unsere-referenzen/"
              buttonString="← Unsere referenzen"
            />
          )}
          {pageContext.lang === "en" && (
            <Button
              buttonURL="/en/achievements/"
              buttonString="← All our achievements"
            />
          )}
        </div>
      </section>
    </Layout>
  )
}

export default RealisationsTemplate

export const Head = ({ location, pageContext }) => {
  const { lang, realisation } = pageContext
  return (
    <>
      {lang === "fr" && (
        <SEO
          title={`${realisation.title} - FEHR Group`}
          description={realisation.metaData.description}
          pathname={location.pathname}
        />
      )}
      {lang === "de" && (
        <SEO
          title={`${realisation.translations.germanTitleSeo} - FEHR Group`}
          description={realisation.translations.germanDescription}
          pathname={location.pathname}
        />
      )}
      {lang === "en" && (
        <SEO
          title={`${realisation.translations.englishTitleSeo} - FEHR Group`}
          description={realisation.translations.englishDescription}
          pathname={location.pathname}
        />
      )}
      {realisation.translations.englishSlug && (
        <link
          rel="alternate"
          href={`/en/achievements/${realisation.translations.englishSlug}/`}
          hrefLang="x-default"
        />
      )}
      <link
        rel="alternate"
        href={`/realisations/${realisation.slug}/`}
        hrefLang="fr"
      />
      {realisation.translations.germanSlug && (
        <link
          rel="alternate"
          href={`/de/unsere-referenzen/${realisation.translations.germanSlug}/`}
          hrefLang="de"
        />
      )}
      {realisation.translations.englishSlug && (
        <link
          rel="alternate"
          href={`/en/achievements/${realisation.translations.englishSlug}/`}
          hrefLang="en"
        />
      )}
    </>
  )
}
